export default __webpack_public_path__ + "static/hbg-13-cfe5abd14ec2e5daefed4713589d6022.jpg";